import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const TaskCongratsPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const resultId = searchParams.get("resultId");
  const sId = searchParams.get("sId");
  const isDemo = searchParams.get("demo") === "true";

  const taskId = searchParams.get("taskId");
  const isMoreAccess = searchParams.get("moreAccess") === "true";
  const [showDeepLinkFallback, setShowDeepLinkFallback] = useState(false);
  const DEEP_LINK_URL = taskId
    ? `moreaccess://home?taskId=${taskId}&submitted=true`
    : "moreaccess://home";

  const whatsappNumber = "62811118706";
  const message = encodeURIComponent(
    `Quick Survey ID : ${sId}.
Halo, saya ingin bertanya terkait hasil quick survey`
  );

  useEffect(() => {
    if (!isMoreAccess) return;
    window.location.href = DEEP_LINK_URL;
    const timer = setTimeout(() => setShowDeepLinkFallback(true), 2000);
    return () => clearTimeout(timer);
  }, [isMoreAccess]);

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handlePopState = (event: PopStateEvent) => {
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    window.history.replaceState(null, "", window.location.href);
  }, []);

  return (
    <div className="container vh-100 d-flex flex-column justify-content-center align-items-center text-center px-3">
      <div
        className="d-flex justify-content-center align-items-center mb-4"
        style={{
          width: 140,
          height: 140,
          borderRadius: "50%",
          backgroundColor: "#2F76E5",
        }}
      >
        <i
          className="fa-solid fa-check"
          style={{ fontSize: 64, color: "#fff" }}
        />
      </div>

      <h4 className="fw-bold mb-2">
        {isDemo ? "Demo Selesai" : isMoreAccess ? "Tugas Berhasil Dikirim" : "Terima kasih"}
      </h4>
      
      {resultId && !isDemo && !isMoreAccess && (
        <div className="text-muted mb-3" style={{ fontSize: 14 }}>
          Result ID : {resultId}
        </div>
      )}

      {isDemo ? (
        <p className="text-secondary mb-4" style={{ maxWidth: 360 }}>
          Anda telah menyelesaikan form demo.
        </p>
      ) : isMoreAccess ? (
        <>
          <p className="text-secondary mb-4" style={{ maxWidth: 360 }}>
            Data Anda sedang dalam proses verifikasi.
          </p>
          {showDeepLinkFallback && (
            <>
              <p className="text-secondary mb-3" style={{ maxWidth: 360, fontSize: 14 }}>
                Jika aplikasi tidak terbuka otomatis, silakan tekan tombol di bawah ini.
              </p>
              <button
                className="btn btn-primary d-flex align-items-center gap-2 px-4"
                style={{ minHeight: "44px", borderRadius: "999px" }}
                onClick={() => { window.location.href = DEEP_LINK_URL; }}
              >
                Buka Aplikasi
              </button>
            </>
          )}
        </>
      ) : (

        <>
          <p className="text-secondary mb-4" style={{ maxWidth: 360 }}>
            Saat ini data sedang dalam proses QC.
            Insentif akan dikirimkan melalui aplikasi Perfect Store.
          </p>
          <p className="text-secondary mb-4" style={{ maxWidth: 360 }}>
            Apabila ada pertanyaan, silakan hubungi customer support kami.
          </p>
          <a
            href={`https://wa.me/${whatsappNumber}?text=${message}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary d-flex align-items-center gap-2 px-4"
            style={{
              minHeight: "44px",
              borderRadius: "999px",
              textDecoration: "none",
            }}
          >
            Hubungi Customer Support
          </a>
        </>
      )}
    </div>
  );
};

export default TaskCongratsPage;